import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import TrustBadgesStrip from '../components/home/TrustBadgesStrip';
import ServicesSection from '../components/home/ServicesSection';
import WhyChooseUsSection from '../components/home/WhyChooseUsSection';
import GalleryPreview from '../components/home/GalleryPreview';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ServiceAreasSection from '../components/home/ServiceAreasSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navigation />
      <main>
        <HeroSection />
        <TrustBadgesStrip />
        <ServicesSection />
        <WhyChooseUsSection />
        <GalleryPreview />
        <TestimonialsSection />
        <ServiceAreasSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
